import { SpectrumGenerator } from "./SpectrumGenerator.js";
/**
 * Generates a spectrum and returns it.
 * @param peaks - List of peaks to put in the spectrum.
 * @param options - Configuration for spectrum generation.
 * @returns The generated spectrum data.
 */
export function generateSpectrum(peaks, options = {}) {
    const { generator, ...rest } = options;
    return new SpectrumGenerator(generator).generateSpectrum(peaks, rest);
}
//# sourceMappingURL=generateSpectrum.js.map